/* eslint-disable */

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import OrganisationSupportElement from "../../../ui-components/organisation-support-element/organisation-support-element";
import IconSearch from "../../../ui-components/icon-search/icon-search";
import { localize } from "../../../services/localize";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import TagElementMotion from "../../../ui-components/tag-element-motion/tag-element-motion.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";

import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { ORGANISATION_TAGS } from "../../../services/constants.js";
import { Link } from "react-router-dom";

import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import { Size } from "../../../logic/enums.ts";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";

const SEARCH_TYPE__ACCOUNT = "ACCOUNT";

const SearchBar = ({ onChange, setScale }) => {
  return (
    <RaindropMotionFadeUp>
      <div
        className={
          "flex flex-row items-center px-4 gap-2 rounded-lg w-full bg-color-background-tertiary  dark:bg-color-dark-background-secondary mx-4"
        }
      >
        <IconSearch className="w-5 h-5 fill-color-dark-text-secondary" />
        <motion.input
          id={"text-input"}
          type={"text"}
          placeholder={localize("COPY_SEARCH")}
          onChange={onChange}
          onKeyDown={() => {
            setScale(1.1);
          }}
          onKeyUp={() => {
            setScale(1);
          }}
          className={
            "p-2 rounded-lg w-full bg-transparent appearance-none focus:outline-none placeholder-color-dark-text-secondary  outline-transparent border-transparent"
          }
        />
      </div>
    </RaindropMotionFadeUp>
  );
};

const TagList = ({ selectedTag, setSelectedTag }) => {
  const onCancelSelection = () => {
    setSelectedTag("");
  };

  if (selectedTag) {
    return (
      <FlexRow className="justify-center">
        <TagElementMotion value={selectedTag} onClick={() => {}} />
        <RaindropClickable onClick={onCancelSelection}>
          <i className="fas fa-times text-color-dark-text-tertiary text-lg" />
        </RaindropClickable>
      </FlexRow>
    );
  }

  return (
    <div className="flex flex-row w-full gap-2 overflow-x-auto no-scrollbar min-h-[40px] px-4">
      {ORGANISATION_TAGS.map((tag, i) => (
        <RaindropClickable onClick={() => setSelectedTag(tag)} key={tag}>
          <TagElementMotion
            value={tag}
            key={tag}
            index={i}
            // onClick={() => setSelectedTag(tag)}
          />
        </RaindropClickable>
      ))}
    </div>
  );
};

const WaterfallSearchElement = ({
  waterfall,
  onAddNewOrganisation = (p) => {},
  onCancelOrganisation = (p) => {},
  isSupporting = false,
}) => {
  return (
    <div className="flex flex-row w-full gap-4 items-center transition-all">
      <Link
        to={`/raindrop/waterfall/${waterfall.id}`}
        className="flex flex-row items-center w-full gap-4"
      >
        <WaterfallIcon
          username={waterfall.account.username}
          urlOrganisation={waterfall.organisation?.presignedUrlLogo}
          urlUser={waterfall.account.presignedUrl}
        />
        <div className="flex flex-col text-left">
          <h4 className="text-xs font-bold text-color-dark-text-tertiary">
            Waterfall
          </h4>
          <h1 className="">{waterfall.title}</h1>
        </div>
      </Link>

      <div className="flex flex-row ml-auto items-center">
        {isSupporting ? (
          <RaindropButton
            title={"Cancel"}
            style={ButtonStyle.Secondary}
            onClick={() => onCancelOrganisation({ waterfall: waterfall })}
          />
        ) : (
          <RaindropButton
            title={"Support"}
            onClick={() => onAddNewOrganisation({ waterfall: waterfall })}
          />
        )}
      </div>
    </div>
  );
};

const DiscoverSectionButton = ({
  title = "Find Your Friends",
  fromColor = "from-color-raindrop-secondary",
  toColor = "to-pink-400",
  onClick = () => {},
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex flex-row cursor-pointer items-end w-full text-bold h-24 rounded-lg text-left font-bold p-4 text-lg bg-gradient-to-tr  ${fromColor} ${toColor}`}
    >
      {title}
    </div>
  );
};

const DiscoverSection = ({ setSelectedType }) => {
  return (
    <div className="flex flex-row w-full gap-4 ">
      <DiscoverSectionButton
        title={"Find Your Friends"}
        fromColor="from-green-800"
        toColor="to-green-400"
        onClick={() => setSelectedType("ACCOUNT")}
      />
      <DiscoverSectionButton
        title={"Explore Waterfalls"}
        fromColor="from-blue-800"
        toColor="to-blue-400"
        onClick={() => setSelectedType("WATERFALL")}
      />
    </div>
  );
};

const SearchResultList = ({
  searchObjects,
  values,
  setValues,
  showTagList = true,
  selectedTag = null,
  searchType,
  doShowDiscoverSection = true,
  setSelectedType = (p) => {},
  setSelectedTag = (p) => {},
  onAddNewOrganisation = (p) => {},
  onCancelOrganisation = (p) => {},
}) => {
  const wasNoResults = searchObjects && searchObjects.length === 0;

  return (
    <RaindropScrollContainer additionalClassNames="gap-6    ">
      <div className="flex flex-col gap-2 w-full items-center">
        {showTagList && searchType !== SEARCH_TYPE__ACCOUNT && (
          <TagList selectedTag={selectedTag} setSelectedTag={setSelectedTag} />
        )}
      </div>

      {wasNoResults && (
        <RaindropMotionFadeUp>
          <RaindropCard additionalClasses="flex flex-col gap-4 items-center mx-2">
            <RaindropHeading title={"No results found"} />
            <p className="text-color-dark-text-tertiary text-left">
              Looking for something specific? Leave a suggestion!
            </p>
            <RaindropButton
              title={"Leave some feedback"}
              to={"/raindrop/feedback"}
              icon="fa-comment"
              size={Size.Large}
              isFluid={true}
            />
          </RaindropCard>
        </RaindropMotionFadeUp>
      )}

      {doShowDiscoverSection && (
        <DiscoverSection setSelectedType={setSelectedType} />
      )}

      <div className={"flex flex-col gap-4 w-full h-full px-4 "}>
        {searchObjects &&
          searchObjects.map((searchObject) => (
            <RaindropMotionFadeUp key={searchObject.id} id={searchObject.id}>
              {searchObject.__typename === "OrganisationType" && (
                <OrganisationSupportElement
                  organisation={searchObject}
                  to={`/raindrop/organisation/${searchObject.id}`}
                  isSupporting={values.some(
                    (v) =>
                      v.organisation && v.organisation.id === searchObject.id
                  )}
                  values={values}
                  setValues={setValues}
                  onAddNewOrganisation={onAddNewOrganisation}
                  onCancelOrganisation={onCancelOrganisation}
                />
              )}
              {searchObject.__typename === "WaterfallType" && (
                <WaterfallSearchElement
                  waterfall={searchObject}
                  onAddNewOrganisation={onAddNewOrganisation}
                  onCancelOrganisation={onCancelOrganisation}
                  isSupporting={values.some(
                    (v) => v.waterfall && v.waterfall.id === searchObject.id
                  )}
                />
              )}
              {searchObject.__typename === "AccountType" && (
                <AccountSearchElement
                  accountId={searchObject.id}
                  presignedUrl={searchObject.presignedUrl}
                  username={searchObject.username}
                />
              )}
            </RaindropMotionFadeUp>
          ))}
      </div>
    </RaindropScrollContainer>
  );
};

const AccountSearchElement = ({ accountId, presignedUrl, username }) => {
  return (
    <div className="flex flex-col w-full">
      <Link
        to={`/raindrop/account/${accountId}`}
        className="flex flex-row w-full items-center gap-4 transition-all"
      >
        <AccountAvatar presignedUrl={presignedUrl} username={username} />
        <div className="flex flex-col text-left">
          <h4 className="text-xs font-bold text-color-dark-text-tertiary">
            Account
          </h4>
          <p className="">{username}</p>
        </div>
      </Link>
    </div>
  );
};

const RaindropSearch = ({
  userCurrent,
  values,
  setValues,
  isPaused = false,
  isRaindropPlus = false,
  onAddNewOrganisation = () => {},
  onCancelOrganisation = () => {},
}) => {
  const [scale, setScale] = useState(1);

  const [searchObjects, setSearchObjects] = useState(null);

  const [userInput, setUserInput] = useState("");
  const [debouncedUserInput, setDebouncedUserInput] = useState("");

  const [selectedType, setSelectedType] = useState("ALL");

  const [selectedTag, setSelectedTag] = useState("");

  const showTagList = userInput === "" || selectedTag != null;

  const showFeatured = userInput === "" && selectedTag == null;

  const doShowDiscoverSection =
    selectedType === "ORGANISATION" && userInput === "" && selectedTag === "";

  useEffect(() => {
    const newValues = [...values];
    newValues.forEach((v) => (v.selected = false));
    setValues(newValues);
  }, []);

  useEffect(() => {
    // This is to prevent making five request if you type "annie".  We'll just make one.
    const handler = setTimeout(() => {
      setDebouncedUserInput(userInput);
    }, 700); // 1000 milliseconds delay
    return () => {
      clearTimeout(handler); // Cleanup on unmount or when query changes
    };
  }, [userInput]);

  useEffect(() => {
    fetchGraphQL(
      `
      query {
        searchObjects (
          searchText: "${userInput}"
          tag: "${selectedTag}"
          objectType: "${selectedType}"
        ) {
          __typename
          
          ... on OrganisationType {
            id
            name
            presignedUrlLogo
            isHydrated
          }
          ... on AccountType {
            id
            name
            username
            isFollowing
            presignedUrl
          }
          ... on WaterfallType {
            id
            title
            createdAt
            organisation {
              presignedUrlLogo
            }
            account {
              presignedUrl
            }
          }
        }
      }
    `,
      true
    )
      .then((result) => {
        if (result.errors) {
          console.error("RD-555", result.errors);
          return;
        }

        const sortedSearchObjects = result.data.searchObjects.sort((a, b) => {
          if (a.isHydrated && !b.isHydrated) return -1;
          if (!a.isHydrated && b.isHydrated) return 1;
          return 0;
        });

        setSearchObjects(sortedSearchObjects);
      })
      .catch((error) => {
        console.error("RD-348", error);
      });
  }, [debouncedUserInput, selectedTag, selectedType]);

  return (
    <div
      id={"raindrop-search"}
      className={"flex flex-col  w-full h-full items-center gap-2 xl:pt-6 "}
    >
      <div className="flex xl:hidden">
        <RaindropCircle
          sausageValues={values}
          animate={{ scale: scale }}
          size={"XSMALL"}
          isRaindropPlus={isRaindropPlus}
          isPaused={isPaused}
          accountAwardFeaturedSlug={
            userCurrent?.account?.accountAwardFeatured?.award?.slug
          }
        />
      </div>

      <SearchBar
        onChange={(e) => setUserInput(e.target.value.toLowerCase())}
        setScale={setScale}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
      />
      <SearchResultList
        searchObjects={searchObjects}
        values={values}
        setValues={setValues}
        isRaindropPlus={isRaindropPlus}
        showTagList={showTagList}
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        doShowDiscoverSection={doShowDiscoverSection}
        setSelectedType={setSelectedType}
        showFeatured={showFeatured}
        onAddNewOrganisation={onAddNewOrganisation}
        onCancelOrganisation={onCancelOrganisation}
      />
    </div>
  );
};

export default RaindropSearch;
